import { Box } from '@mui/material';
import Logo from '../Logo';
import { ProgressBar } from '../ProgressBar';

export function AppProgressBar() {
    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            width="200px"
            m="8em auto"
        >
            <Box mb={2}>
                <Logo size="lg" />
            </Box>
            <ProgressBar duration={1000} />
        </Box>
    );
}
